(() => {
  'use strict';
  if (window.ctCartRewardLoaded) return;
  window.ctCartRewardLoaded = true;
  const duration = 600000;
  const timerKey = 'ct-cart-countdown-v4';
  let memory = null;
  let cartToken = '';
  let syncing = false;
  let syncAgain = false;
  let syncTimer = 0;
  const banner = () => document.querySelector('[data-ct-cart-reward]');
  const drawer = () => document.querySelector('cart-drawer');
  const nonEmpty = element => element && Number(element.dataset.itemCount) > 0 && !drawer()?.classList.contains('is-empty');
  function read() {
    try { return JSON.parse(localStorage.getItem(timerKey) || 'null'); } catch (_) { return memory; }
  }
  function write(value) {
    memory = value;
    try {
      if (value) localStorage.setItem(timerKey, JSON.stringify(value));
      else localStorage.removeItem(timerKey);
    } catch (_) {}
  }
  function update() {
    const element = banner();
    if (!element) return null;
    const wait = element.querySelector('[data-ct-reward-wait]');
    const offer = element.querySelector('[data-ct-reward-offer]');
    const applied = element.querySelector('[data-ct-reward-applied]');
    const claim = element.querySelector('[data-ct-reward-claim]');
    element.dataset.ready = 'false';
    wait.hidden = offer.hidden = applied.hidden = true;
    claim.removeAttribute('href');
    claim.setAttribute('aria-disabled', 'true');
    element.hidden = true;
    if (!nonEmpty(element)) { write(null); cartToken = ''; return null; }
    const state = read();
    const now = Date.now();
    if (!cartToken || !state || state.cartToken !== cartToken || !Number.isFinite(state.startedAt) || state.startedAt > now) return null;
    const remaining = Math.max(0, Math.ceil((state.startedAt + duration - now) / 1000));
    const clock = element.querySelector('[data-ct-reward-clock]');
    const time = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
    if (clock.textContent !== time) clock.textContent = time;
    if (remaining > 0) {
      element.hidden = false;
      wait.hidden = false;
      return null;
    }
    const expiry = element.dataset.expires ? Date.parse(element.dataset.expires) : Infinity;
    const valid = element.dataset.offerEnabled === 'true' && Boolean(element.dataset.code) && !Number.isNaN(expiry) && now < expiry;
    if (!valid) return null;
    element.hidden = false;
    if (element.dataset.applied === 'true') { applied.hidden = false; return null; }
    offer.hidden = false;
    claim.href = element.dataset.claimUrl;
    claim.removeAttribute('aria-disabled');
    element.dataset.ready = 'true';
    return element;
  }
  async function sync() {
    const element = banner();
    if (!element) return;
    if (!nonEmpty(element)) { update(); return; }
    if (syncing) { syncAgain = true; return; }
    syncing = true;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin',headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (!cart.item_count) { write(null); cartToken = ''; return; }
      const token = String(cart.token || '').split('?')[0];
      if (!token) return;
      cartToken = token;
      const now = Date.now();
      const state = read();
      if (!state || state.cartToken !== token || !Number.isFinite(state.startedAt) || state.startedAt > now) {
        if (drawer()?.classList.contains('active')) write({cartToken:token,startedAt:now});
      }
    } catch (_) {} finally {
      syncing = false;
      update();
      if (syncAgain) { syncAgain = false; scheduleSync(); }
    }
  }
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 80);
  }
  document.addEventListener('click', event => {
    const target = event.target.closest?.('#CartDrawer-Checkout, [data-ct-reward-claim]');
    if (!target) return;
    const element = update();
    if (!element) {
      if (target.matches('[data-ct-reward-claim]')) event.preventDefault();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(element.dataset.claimUrl);
  }, true);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { update(); scheduleSync(); } });
  window.addEventListener('storage', event => { if (event.key === timerKey) update(); });
  document.addEventListener('shopify:section:load', scheduleSync);
  const container = drawer();
  if (container) {
    const observer = new MutationObserver(records => {
      if (records.some(record => !record.target.closest?.('[data-ct-cart-reward]'))) { update(); scheduleSync(); }
    });
    observer.observe(container, {subtree:true,childList:true,attributes:true,attributeFilter:['class']});
  }
  window.setInterval(update, 1000);
  update();
  sync();
})();
